import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getCurrentPollingResultsForProject } from '../../project-actions';
import ProjectPoll from './ProjectPoll';
import { useProject } from '../../project-hooks/useProject';
import { SHOW_POLLS_ON_PROJECT } from '../../../constants/features/constants';

const POLL_INTERVAL_IN_SECONDS = 10;

const ProjectPolls = () => {
    const dispatch = useDispatch();
    const project = useProject();
    const [pollData, setPollData] = useState({});
    const pollFeatureEnabled = useSelector((state) => state.features[SHOW_POLLS_ON_PROJECT]);
    const showPolls = pollFeatureEnabled && project?.profile?.showPolls;

    useEffect(() => {
        const fetchPollingData = async () => {
            if (showPolls) {
                dispatch(getCurrentPollingResultsForProject({ projectId: project.id })).then((result) =>
                    setPollData(result)
                );
            }
        };

        const intervalId = setInterval(() => {
            fetchPollingData();
        }, 1000 * POLL_INTERVAL_IN_SECONDS);

        fetchPollingData();

        return () => {
            clearInterval(intervalId);
        };
    }, [dispatch, project.id, showPolls]);

    if (!showPolls || !project || !pollData?.polls || pollData?.polls?.length === 0) {
        return null;
    }

    return (
        <div>
            {pollData.polls?.map((poll) => (
                <ProjectPoll key={poll.id} poll={poll} />
            ))}
        </div>
    );
};

export default ProjectPolls;
